export default {
    translation: {
        breadcrumbs: {
            '404': '404',
            '500': '500',
            'app': 'App',
            'horizontal': 'Orizzontale',
            'horizontalMenu': 'Menu orizzontale',
            'general': 'Generale',
            'component': 'Component',
            'features': 'Funzioni',
            'applications': 'Applicazioni',
            'dashboard': 'cruscotto',
            'dashboard1': 'Cruscotto 1',
            'dashboard2': 'Cruscotto 2',
            'dashboard3': 'Cruscotto 3',
            'modules': 'Moduli',
            'agency': 'Agenzia',
            'pages': 'Pagine',
            'gallery': 'Galleria',
            'pricing': 'Prezzi',
            'terms & Conditions': 'Termini e condizioni',
            'feedback': 'Feedback',
            'report': 'Segnala',
            'faq (s)': 'Faq (s)',
            'advancedComponent': 'Componente avanzato',
            'blank': 'Vuoto',
            'session': 'Sessione',
            'login': 'Accesso',
            'register': 'Registrati',
            'lockScreen': 'Blocca schermo',
            'forgotPassword': 'Password dimenticata',
            'uiComponents': 'Componenti UI',
            'alerts': 'Avvisi',
            'appBar': 'App Bar',
            'avatars': 'Avatar',
            'buttons': 'Pulsanti',
            'bottomNavigations': 'Navigazione inferiore',
            'badges': 'Distintivo',
            'cards': 'Carte',
            'cardsMasonry': 'Carte in muratura',
            'chip': 'Patata fritta',
            'dialog': 'Dialogo',
            'dividers': 'divisori',
            'drawers': 'Cassetti',
            'popover': 'Popover',
            'expansionPanel': 'Pannello di espansione',
            'gridList': 'lista della griglia',
            'list': 'Elenco',
            'menu': 'Menu',
            'popoverAndToolTip': 'popover e suggerimento',
            'progress': 'Progresso',
            'snackbar': 'snack bar',
            'selectionControls': 'Controlli di selezione',
            'advanceUiComponents': 'Advance UI Components',
            'dateAndTimePicker': 'Selezione data e ora',
            'tabs': 'Schede',
            'stepper': 'Stepper',
            'notification': 'Notifica',
            'sweetAlert': 'Sweet Alert',
            'autoComplete': 'Completamento automatico',
            'aboutUs': 'Chi siamo',
            'widgets': 'widget di',
            'forms': 'Forme',
            'formElements': 'Elementi del modulo',
            'textField': 'Campo di testo',
            'selectList': 'Seleziona lista',
            'charts': 'Grafici',
            'reCharts': 'Re Grafici',
            'reactChartjs2': 'React Chartjs 2',
            'icons': 'Icone',
            'themifyIcons': 'Themify Icone',
            'simpleLineIcons': 'Icone linea semplice',
            'materialIcons': 'Icone materiali',
            'fontAwesome': 'font Eccezionale',
            'tables': 'Tabelle',
            'basic': 'Base',
            'dataTable': 'Tabella dati',
            'responsive': 'di risposta',
            'reactTable': 'Tabella di reazione',
            'maps': 'Mappe',
            'googleMaps': 'Google Mappe',
            'leafletMaps': 'Mappe dei volantini',
            'inbox': 'Posta in arrivo',
            'users': 'Utenti',
            'userProfile1': 'Profilo utente 1',
            'userProfile2': 'Profilo utente 2',
            'userManagement': 'Gestione utenti',
            'userProfile': 'Profilo utente',
            'userList': 'Elenco utenti',
            'calendar': 'Calendar',
            'cultures': 'Culture',
            'dnd': 'Dnd',
            'selectable': 'Selezionabile',
            'customRendering': 'Rendering personalizzato',
            'chat': 'Chiacchierare',
            'toDo': 'Fare',
            'editor': 'editore',
            'wysiwygEditor': 'editore WYSIWYG',
            'quillEditor': 'Quill editore',
            'reactAce': 'Reagire Ace',
            'dragAndDrop': 'Trascina e rilascia',
            'reactDragula': 'Reagire Dragula',
            'reactDnd': 'Reagire Dnd',
            'blogManagement': 'Gestione blog',
            'ecommerce': 'E-commercio',
            'shopList': 'Elenco negozi',
            'shopGrid': 'Negozio Griglia',
            'invoice': 'Fattura',
            'multilevel': 'Multilevel',
            'sublevel': 'Sottolivello',
            'dateTimePicker': 'Selezione data e ora',
            'user': 'Utente',
            'miscellaneous': 'miscellaneo',
            'promo': 'Promo',
            'gettingStarted': 'Iniziare',
            'shop': 'Negozio',
            'cart': 'Carrello',
            'checkout': 'Check-out',
            'saas': 'SAAS',
            'multiLevel': 'MultiLevel',
            'level1': 'Livello 1',
            'level2': 'Livello 2',
            'boxed': 'boxed',
            'news': 'notizia',
            'extensions': 'estensioni',
            'imageCropper': 'Cropper di immagini',
            'videoPlayer': 'Lettore video',
            'dropzone': 'Zona di rilascio',
            'faq(s)': 'Faq(s)',
            'terms&Conditions': 'Termini & Condizioni',
            'crm': 'CRM',
            'projects': 'progetti',
            'projectDetail': 'Dettaglio del progetto',
            'clients': 'clienti',
            'reports': 'rapporti'
        },
        'widgets': {
            'totalEarns': 'Totale guadagna',
            'emailsStatistics': 'Statistiche e-mail',
            'totalRevenue': 'Totale Reddito',
            'onlineVistors': 'Online Vistors',
            'trafficSources': 'Sorgenti di traffico',
            'RecentOrders': 'Ordini recenti',
            'topSellings': 'Superiore sellings',
            'productReports': 'Rapporti sui prodotti',
            'productStats': 'Statistiche prodotto',
            'ComposeEmail': 'Scrivi e-mail',
            'employeePayroll': 'Dipendente Libro paga',
            'visitors': 'Visitatori',
            'orders': 'Ordini',
            'ratings': 'Giudizi',
            'orderStatus': 'Stato dell\'ordine',
            'totalSales': 'Vendite totali',
            'netProfit': 'Profitto netto',
            'overallTrafficStatus': 'Stato generale del traffico',
            'tax': 'Tasse',
            'expenses': 'Spese',
            'currentTime': 'Ora corrente',
            'currentDate': 'Dati corrente',
            'todayOrders': 'Oggi Ordini',
            'toDoList': 'A Fare elenchi',
            'discoverPeople': 'Scopri persone',
            'commments': 'Commenti',
            'newCustomers': 'Nuovi clienti',
            'recentNotifications': 'Notifiche recenti',
            'appNotifications': 'Notifiche app',
            'newEmails': 'Nuove email',
            'siteVisitors': 'Visitatori del sito',
            'socialCompanines': 'Social Companines',
            'recentActivities': 'Attività recenti',
            'recentOrders': 'Ordini recenti',
            'gallery': 'Galleria',
            'pricing': 'Prezzi',
            'enterpriseEdition': 'Edizione impresa',
            'personalEdition': 'Personale Edizione',
            'teamEdition': 'Squadra Edizione',
            'standard': 'Standard',
            'advanced': 'Avanzato',
            'master': 'Maestro',
            'Mega': 'Mega',
            'logIn': 'Accedi',
            'signUp': 'Registrati',
            'lockScreen': 'Blocca schermo',
            'alertsWithLink': 'Avvisi con collegamento',
            'additionalContent': 'Contenuto aggiuntivo',
            'alertDismiss': 'Alert Dismiss',
            'uncontrolledDisableAlerts': 'Disattivare gli avvisi non controllati',
            'contexualAlerts': 'avvisi contestuali',
            'alertsWithIcons': 'Avvisi con icone',
            'simpleAppBars': 'Semplice App Barre',
            'appBarsWithButtons': 'App Bar con pulsanti',
            'imageAvatars': 'Avatar di immagini',
            'lettersAvatars': 'Lettere Avatar',
            'iconsAvatars': 'Icone Avatar',
            'flatButtons': 'Flat pulsanti',
            'raisedButton': 'Pulsante alzato',
            'buttonWithIconAndLabel': 'Pulsante con icona ed etichetta',
            'floatingActionButtons': 'Pulsanti di azione mobili',
            'iconButton': 'Pulsante icona',
            'socialMediaButton': 'Pulsante Sociale Media',
            'reactButton': 'Pulsante Reagisci',
            'buttonOutline': 'Schema pulsante',
            'buttonSize': 'Dimensione del pulsante',
            'buttonState': 'Stato pulsante',
            'buttonNavigationWithNoLabel': 'pulsante Navigazione senza etichetta',
            'buttonNavigation': 'Pulsante di navigazione',
            'iconNavigation': 'Icon Navigation',
            'badgeWithHeadings': 'Distintivo con titoli',
            'contexualVariations': 'Variazioni Contexual',
            'badgeLinks': 'Collegamenti distintivo',
            'materialBadge': 'Distintivo materiale',
            'simpleCards': 'Semplice Carte',
            'backgroundVarient': 'Varietà sfondo',
            'cardOutline': 'Scheda Struttura',
            'overlayCard': 'copertura Carta',
            'cardGroup': 'Carta Gruppo',
            'cardTitle': 'Titolo scheda',
            'speacialTitleTreatment': 'Trattamento del titolo specifico',
            'chipWithClickEvent': 'Patata fritta con evento clic',
            'chipArray': 'Patata fritta schieramento',
            'dialogs': 'Dialoghi',
            'listDividers': 'Elenco divisori',
            'insetDividers': 'Inset divisori',
            'temporaryDrawers': 'Cassetti temporanei',
            'permanentDrawers': 'Cassetti permanenti',
            'simpleExpansionPanel': 'Semplice Espansione Pannello',
            'controlledAccordion': 'Controlled Fisarmonica',
            'secondaryHeadingAndColumns': 'Intestazione e colonne secondarie',
            'imageOnlyGridLists': 'Solo elenchi di griglia di immagini',
            'advancedGridLists': 'Avanzate Griglia elenchi',
            'singleLineGridLists': 'Elenchi di griglia a linea singola',
            'simpleLists': 'Liste semplici',
            'folderLists': 'Elenchi cartelle',
            'listItemWithImage': 'Elemento elenco con immagine',
            'switchLists': 'Interruttore elenchi',
            'insetLists': 'Elenco inserire',
            'nestedLists': 'Nidificato elenchi',
            'checkboxListControl': 'Controllo elenco caselle di controllo',
            'pinedSubHeader': 'Intestazione secondaria intasata',
            'InteractiveLists': 'Elenchi interattivi',
            'simpleMenus': 'Menu semplici',
            'selectedMenu': 'Menu selezionato',
            'maxHeightMenu': 'Menu altezza massima',
            'changeTransition': 'Cambia transizione',
            'paper': 'Carta',
            'anchorPlayGround': 'Ancora Giocare Terra',
            'tooltip': 'Troppo lTip',
            'positionedToolTips': 'Snackbar posizionato',
            'circularProgressBottomStart': 'Inizio progresso circolare iniziale',
            'interactiveIntegration': 'Integrazione interattiva',
            'determinate': 'Determinato',
            'linearProgressLineBar': 'Barra di avanzamento lineare',
            'indeterminate': 'Indeterminato',
            'buffer': 'Buffer',
            'query': 'domanda',
            'transitionControlDirection': 'Direzione del controllo di transizione',
            'simpleSnackbar': 'Semplice Snack bar',
            'positionedSnackbar': 'Snack bar posizionato',
            'contexualColoredSnackbars': 'Contexual Colorato snackbars',
            'simpleCheckbox': 'Semplice casella di controllo',
            'interminateSelection': 'Interminate Selezione',
            'disabledCheckbox': 'casella di controllo disattivato',
            'customColorCheckbox': 'Casella di controllo colori personalizzati',
            'VerticalStyleCheckbox': 'casella di controllo stile verticale',
            'horizontalStyleCheckbox': 'casella di controllo stile orizzontale',
            'radioButtons': 'Pulsanti Radio',
            'disabledRadio': 'Radio disabilitata',
            'withError': 'Con Errore',
            'switches': 'swiches',
            'dateAndTimePicker': 'Selezione dati e ora',
            'defaultPicker': 'Selettore predefinito',
            'timePicker': 'Tempo Picker',
            'weekPicker': 'Selezionatore settimanale',
            'defaultDatePicker': 'Selezione data predefinita',
            'customPicker': 'Selettore personalizzato',
            'tabs': 'Schede',
            'fixedTabs': 'linguetta Fisso',
            'basicTab': 'Scheda di base',
            'wrappedLabels': 'Etichette avvolte',
            'centeredLabels': 'Etichette centrate',
            'forcedScrolledButtons': 'Pulsanti a scorrimento forzato',
            'iconsTabs': 'Schede icone',
            'withDisableTabs': 'Disabilita tabulazioni',
            'iconWithLabel': 'Icona con etichetta',
            'stepper': 'stepper',
            'horizontalLinear': 'Orizzontale Lineare',
            'horizontalNonLinear': 'Orizzontale Non Lineare',
            'horizontalLinerAlternativeLabel': 'Etichetta alternativa orizzontale fodera',
            'horizontalNonLinerAlternativeLabel': 'Etichetta alternativa non lineare orizzontale',
            'verticalStepper': 'Vertical Stepper',
            'descriptionAlert': 'Descrizione avviso',
            'customIconAlert': 'costume Icona Mettere in guardia',
            'withHtmlAlert': 'Con html Mettere in guardia',
            'promptAlert': 'Richiesta Mettere in guardia',
            'passwordPromptAlert': 'Avviso richiesta parola d\'ordine',
            'customStyleAlert': 'costume Stile Mettere in guardia',
            'autoComplete': 'Completamento automatico',
            'reactSelect': 'Reagisci Seleziona',
            'downshiftAutoComplete': 'Downshift Auto Complete',
            'reactAutoSuggests': 'Reagisce suggerimenti automatici',
            'aboutUs': 'Chi siamo',
            'ourVission': 'Nostro Vission',
            'ourMissions': 'Le nostre missioni',
            'ourMotivation': 'La nostra motivazione',
            'defualtReactForm': 'defualt Reagire Modulo',
            'url': 'url',
            'textArea': 'La zona di testo',
            'file': 'File',
            'formGrid': 'Modulo Griglia',
            'inlineForm': 'In linea Modulo',
            'inputSizing': 'Ridimensionamento dell\'ingresso',
            'inputGridSizing': 'Ingresso Griglia dimensionamento',
            'hiddenLabels': 'Etichette nascoste',
            'formValidation': 'Modulo Validazione',
            'number': 'Numero',
            'date': 'Dati',
            'time': 'Tempo',
            'color': 'Colore',
            'search': 'Cerca',
            'selectMultiple': 'Seleziona più',
            'inputWithSuccess': 'Input con successo',
            'inputWithDanger': 'Ingresso Con Pericolo',
            'simpleTextField': 'Campo di testo semplice',
            'componet': 'Componenti',
            'layouts': 'layout',
            'inputAdorements': 'Ingresso Adorements',
            'formattedInputs': 'Ingresso formattati',
            'simpleSelect': 'Selezione semplice',
            'nativeSelect': 'Selezione nativa',
            'MutltiSelectList': 'Mutlti Selezionare Elenco',
            'lineChart': 'Grafico a linee',
            'barChart': 'Bar Grafico',
            'stackedBarChart': 'Grafico a barre in pila',
            'lineBarAreaChart': 'Grafico area barra delle linee',
            'areaChart': 'La zona Grafico',
            'stackedAreaChart': 'Grafico ad la zona in Pila',
            'verticalChart': 'Grafico verticale',
            'radarChart': 'Grafico radar',
            'doughnut': 'Ciambella',
            'polarChart': 'Grafico polare',
            'pieChart': 'Grafico a torta',
            'bubbleChart': 'Grafico a bolle',
            'horizontalBar': 'horizonatl Bar',
            'basicTable': 'Tabella di base',
            'contexualColoredTable': 'Tavolo colorato contex',
            'dataTable': 'Tabella dati',
            'employeeList': 'Elenco dei dipendenti',
            'responsiveTable': 'Tabella reattiva',
            'responsiveFlipTable': 'Responsive Flip Table',
            'reactGridControlledStateMode': 'React Grid Controlled State Mode',
            'googleMaps': 'Google Maps',
            'productsReports': 'Rapporti sui prodotti',
            'taskList': 'Elenco attività',
            'basicCalender': 'Calendario di base',
            'culturesCalender': 'Calendario delle culture',
            'dragAndDropCalender': 'Trascina e rilascia calendario',
            'selectableCalender': 'Calendario selezionabile',
            'customRendering': 'Rendering personalizzato',
            'customCalender': 'Calendario personalizzato',
            'searchMailList': 'Cerca mail list',
            'forgetPassword': 'Parola d\'ordine dimenticata',
            'QuickLinks': 'Collegamenti rapidi',
            'upgrade': 'aggiornamento',
            'app': 'App',
            'addNew': 'Aggiungi nuovo',
            'orderDate': 'Ordine Data',
            'status': 'Stato',
            'trackingNumber': 'Numero di tracciamento',
            'action': 'Azione',
            'designation': 'Designazione',
            'subject': 'soggetto',
            'send': 'Invia',
            'saveAsDrafts': 'Salva venire bozze',
            'onlineSources': 'Sorgenti in linea',
            'lastMonth': 'Ultimo mese',
            'widgets': 'widget',
            'listing': 'Elenco',
            'paid': 'Pagato',
            'refunded': 'Rimborsato',
            'done': 'Fatto',
            'pending': 'In sospeso',
            'cancelled': 'Cancelled',
            'approve': 'Approva',
            'following': 'A seguire',
            'follow': 'Seguire',
            'graphs & Charts': 'Grafici e grafici',
            'open': 'Apri',
            'bounced': 'Bounced',
            'spam': 'Spam',
            'unset': 'unset',
            'bandwidthUse': 'Uso della larghezza di banda',
            'dataUse': 'Utilizzo dati',
            'unsubscribe': 'Annulla iscrizione',
            'profile': 'Profilo',
            'messages': 'Messaggi',
            'support': 'Supporto',
            'faq (s)': 'Faq (s)',
            'upgradePlains': 'aggiornamento Plains',
            'logOut': 'Esci',
            'mail': 'posta',
            'adminTheme': 'Tema di amministrazione',
            'wordpressTheme': 'Tema Wordpress',
            'addToCart': 'Aggiungi al carrello',
            'plan': 'Piano',
            'basic': 'Base',
            'pro': 'Pro',
            'startToBasic': 'Inizia per base',
            'upgradeToPro': 'Aggiorna a Pro',
            'upgradeToAdvance': 'Aggiornamento per l\'avanzamento',
            'comparePlans': 'Confronta i piani',
            'free': 'Gratuito',
            'frequentlyAskedQuestions': 'Domande frequenti',
            'searchIdeas': 'Cerca idee',
            'startDate': 'Dati di inizio',
            'endDate': 'Fine Data',
            'category': 'Categoria',
            'apply': 'Applica',
            'downloadPdfReport': 'Scarica rapporto Pdf',
            'yesterday': 'Ieri',
            'totalOrders': 'Totale ordini',
            'totalVisitors': 'Visitatori totali',
            'typeYourQuestions': 'Digita le tue domande',
            'username': 'Nome utente',
            'password': 'Parola d\'ordine',
            'signIn': 'Accedi',
            'enterYourPassword': 'Inserisci la tua password',
            'alreadyHavingAccountLogin': 'Hai già accesso all\'account',
            'composeMail': 'Scrivi messaggio',
            'issue': 'Problema',
            'recentChat': 'Chiacchierare recente',
            'previousChat': 'Chiacchierare precedente',
            'all': 'Tutti',
            'filters': 'Filtri',
            'deleted': 'eliminata',
            'starred': 'Ha recitato',
            'frontend': 'Fine frontale',
            'backend': 'backend',
            'api': 'Api',
            'simpleAppBar': 'Semplice App Bar',
            'recents': 'Recenti',
            'cardLink': 'Collegamento scheda',
            'anotherLink': 'Un altro collegamento',
            'cardSubtittle': 'sottotitolo della carta',
            'confirmationDialogs': 'Dialoghi di conferma',
            'deletableChip': 'deletable Patata fritta',
            'customDeleteIconChip': 'costume Elimina Icona Patata fritta',
            'openAlertDialog': 'Aperto Mettere in guardia Dialogo',
            'openResponsiveDialog': 'Aperto di risposta Dialogo',
            'openSimpleDialog': 'Aperto Semplice Dialogo',
            'openFormDialog': 'Aperto Modulo Dialogo',
            'follower': 'Seguace',
            'important': 'Importante',
            'private': 'Privato',
            'openLeft': 'Aperto Sinistra',
            'openRight': 'Aperto Destra',
            'openTop': 'Aperto Superiore',
            'openBottom': 'Aperto Parte inferiore',
            'selectTripDestination': 'Selezionare Viaggio Destinazione',
            'pinnedSubheaderList': 'Pinned Subheader Elenco',
            'singleLineItem': 'singolo Linea Articolo',
            'acceptTerms': 'Accettare condizioni',
            'optionA': 'Opzione A',
            'optionB': 'Opzione B',
            'optionC': 'Opzione C',
            'optionM': 'Opzione M',
            'optionN': 'Opzione N',
            'optionO': 'Opzione O',
            'customColor': 'costume Colore',
            'centeredTabs': 'centrato Tabs',
            'multipleTabs': 'multiplo Tabs',
            'preventScrolledButtons': 'Impedire scorrere pulsanti',
            'browse': 'Navigare',
            'formValidate': 'Modulo Convalidare',
            'code': 'Codice',
            'company': 'Azienda',
            'price': 'Prezzo',
            'change': 'Modificare',
            'high': 'alto',
            'low': 'Basso',
            'volume': 'Volume',
            'personalDetails': 'Dettagli personali',
            'occupazione': 'Occupazione',
            'companyName': 'Nome dell\'azienda',
            'phoneNo': 'Numero di telefono',
            'city': 'Città',
            'zipCode': 'Codice postale',
            'updateProfile': 'Aggiorna profilo',
            'reject': 'Rifiuta',
            'exportToExcel': 'Esporta in Excel',
            'addNewUser': 'Aggiungi nuovo utente',
            'workWeek': 'Settimana lavorativa',
            'agenda': 'Agenda',
            'conference': 'Conferenza',
            'multilevel': 'Multilevel',
            'dailySales': 'Vendite giornaliere',
            'today': 'Oggi',
            'campaignPerformance': 'Rendimento della campagna',
            'supportRequest': 'Richiesta di supporto',
            'usersList': 'Elenco degli utenti',
            'lastWeek': 'La settimana scorsa',
            'buyMore': 'Compra di più',
            'trafficChannel': 'Canale del traffico',
            'stockExchange': 'Borsa valori',
            'tweets': 'tweets',
            'ourLocations': 'Le nostre sedi',
            'sales': 'I saldi',
            'to': 'A',
            'shipTo': 'Spedire a',
            'description': 'Descrizione',
            'unitPrice': 'Prezzo unitario',
            'total': 'Totale',
            'note': 'Nota',
            'chipWithAvatar': 'chip Con l\'avatar',
            'chipWithTextAvatar': 'Chip con Avatar di testo',
            'chipWithIconAvatar': 'Chip con Icon Avatar',
            'customClickableChip': 'Chip cliccabile personalizzato',
            'outlineChip': 'Chip di contorno',
            'disableChip': 'Disattiva chip',
            'alertDialog': 'finestra di avviso',
            'animatedSlideDialogs': 'Dialoghi di diapositive animate',
            'fullScreenDialogs': 'Dialoghi a schermo intero',
            'formDialogs': 'Dialoghi modulo',
            'simpleDialogs': 'Dialoghi semplici',
            'responsiveFullScreen': 'Schermo intero reattivo',
            'primary': 'Primario',
            'social': 'Sociale',
            'user': 'Utente',
            'admin': 'Admin',
            'permanentdrawer': 'Cassetto permanente',
            'persistentdrawer': 'Cassetto persistente',
            'swiches': 'swiches',
            'horizontalLinearAlternativeLabel': 'Etichetta alternativa lineare orizzontale',
            'horizontalNonLinearAlternativeLabel': 'Etichetta alternativa non lineare orizzontale',
            'notifications': 'notifiche',
            'basicAlert': 'Avviso di base',
            'successAlert': 'Avviso di successo',
            'warningAlert': 'Avviso di allerta',
            'reactAutoSuggest': 'Reagisci suggerimento automatico',
            'components': 'componenti',
            'inputAdornments': 'ingresso Adorements',
            'multiSelectList': 'Lista multipla',
            'contextualColoredTable': 'Tavolo colorato contex',
            'updateYourEmailAddress': 'Aggiorna il tuo indirizzo email',
            'selectADefaultAddress': 'Seleziona un indirizzo predefinito',
            'activity': 'Attività',
            'basicCalendar': 'Calendario di base',
            'culturesCalendar': 'Calendario delle culture',
            'dragAndDropCalendar': 'Trascina e lascia calendario',
            'quillEditor': 'Editor di quill',
            'reactDND': 'Reagire DND',
            'dragula': 'Dragula',
            'AcceptorrRejectWithin': 'Accettare o rifiutare all\'interno',
            'quoteOfTheDay': 'Citazione del giorno',
            'updated10Minago': 'Aggiornato 10 minuti fa',
            'personalSchedule': 'Programma personale',
            'activeUsers': 'Utenti attivi',
            'totalRequest': 'Richiesta totale',
            'new': 'Nuovo',
            'ShareWithFriends': 'Condividere con gli amici!',
            'helpToShareText': 'Aiutaci a diffondere il mondo condividendo il nostro sito Web con i tuoi amici e follower sui social media!',
            'thisWeek': 'Questa settimana',
            'howWouldYouRateUs': 'Come valuteresti?',
            'booking': 'Prenotazione',
            'confirmed': 'Confermato',
            'monthly': 'mensile',
            'weekly': 'settimanale',
            'target': 'bersaglio',
            'totalActiveUsers': 'Totale utenti attivi',
            'deadline': 'Scadenza',
            'team': 'Squadra',
            'projectManagement': 'Gestione di progetto',
            'latestPost': 'L\'ultimo post',
            'projectTaskManagement': 'Gestione delle attività del progetto',
            'selectProject': 'Seleziona Progetto',
            'activityBoard': 'Commissione di attività',
            'checklist': 'lista di controllo',
            'baseConfig': 'Base Config',
            'customControlBar': 'Barra di controllo personalizzata',
            'withDownloadButton': 'Con il pulsante Download',
            'httpLiveStreaming': 'HTTP Live Streaming',
            'keyboardShortcuts': 'Tasti rapidi',
            'preview': 'Anteprima',
            'croppedImage': 'Immagine ritagliata',
            'transactionList': 'elenco delle transazioni',
            'transferReport': 'rapporto di trasferimento',
            'expenseCategory': 'categoria di spesa',
            'upcomingEvents': 'Prossimi eventi',
            'OngoingProjects': 'progetti in corso',
            'ProjectStatus': 'stato del progetto',
            'LiveChatSupport': 'supporto live chat'
        },
        'components': {
            'buyNow': 'Acquista ora',
            'alreadyHavingAccountSignIn': 'Hai già accesso all\'account',
            'enterYourPassword': 'Inserisci la tua password',
            'unlock': 'Unlock',
            'enterPasswords': 'Inserisci password',
            'resetPassword': 'Resest Password',
            'pageNotfound': 'Pagina non trovata',
            'goToHomePage': 'Vai alla pagina iniziale',
            'sorryServerGoesWrong': 'Spiacente Server va male',
            'persistentDrawer': 'Cassetto persistente',
            'back': 'Indietro',
            'next': 'Avanti',
            'completeStep': 'Completa il passaggio',
            'withHtml': 'Con Html',
            'prompt': 'Richiesta',
            'withDescription': 'Con Descrizione',
            'success': 'Successo',
            'passwordPrompt': 'Richiesta parola d\'ordine',
            'warning': 'avvertimento',
            'customIcon': 'Icona personalizzata',
            'customStyle': 'Stile personalizzato',
            'basic': 'Basic',
            'submit': 'Invia',
            'compose': 'Componi',
            'sendMessage': 'Invia messaggio',
            'addNewTasks': 'Aggiungi nuove attività',
            'addToCart': 'Aggiungi al carrello',
            'payNow': 'Paga adesso',
            'print': 'Stampa',
            'cart': 'Carrello',
            'viewCart': 'Visualizza il carrello',
            'checkout': 'Dai un\'occhiata-su',
            'summary': 'Sommario',
            'yesterday': 'Ieri',
            'last7Days': 'Ultimi 7 giorni',
            'last1Month': 'Ultimo 1 mese',
            'last6Month': 'Ultimo 6 mesi',
            'spaceUsed': 'Spazio utilizzato',
            'followers': 'Seguace',
            'trending': 'trending',
            'paid': 'Pagato',
            'refunded': 'rimborsato',
            'done': 'Fatto',
            'pending': 'in attesa di',
            'cancelled': 'Annullato',
            'approve': 'Approvare',
            'week': 'Settimana',
            'month': 'Mese',
            'year': 'Anno',
            'today': 'Oggi',
            'popularity': 'Popolarità',
            'email': 'E-mail',
            'drafts': 'bozze',
            'sent': 'Inviato',
            'trash': 'Spazzatura',
            'all': 'Tutti',
            'do': 'Fare',
            'title': 'Titolo',
            'projectName': 'Nome del progetto',
            'companyName': 'Nome della ditta',
            'openAlert': 'Apri avviso',
            'slideInAlertDialog': 'slide Nella finestra di avviso',
            'openFullScreenDialog': 'Apri finestre di dialogo a schermo intero',
            'basicChip': 'Chip di base',
            'clickableChip': 'Chip cliccabile',
            'left': 'Sinistra',
            'right': 'Destra',
            'expansionPanel1': 'Pannello di espansione 1',
            'expansionPanel2': 'Pannello di espansione 2',
            'generalSetting': 'Impostazioni generali',
            'advancedSettings': 'Impostazioni avanzate',
            'firstName': 'Nome di battesimo',
            'lastName': 'Cognome',
            'occupation': 'Occupazione',
            'phoneNo': 'Telefono n',
            'address': 'Indirizzo',
            'city': 'Città',
            'state': 'Stato',
            'zipCode': 'Cap',
            'social Connection': 'Connessione sociale',
            'emailPrefrences': 'preferenze email',
            'myProfile': 'Il mio profilo',
            'product': 'Prodotto',
            'quantity': 'Quantità',
            'totalPrice': 'Prezzo totale',
            'removeProduct': 'Rimuovi prodotto',
            'mobileNumber': 'Numero di cellulare',
            'address2Optional': 'Indirizzo 2 (facoltativo)',
            'country': 'Nazione',
            'zip': 'Cerniera lampo',
            'saveContinue': 'Salva e continua',
            'placeOrder': 'Invia ordine',
            'payment': 'Pagamento',
            'billingAddress': 'Indirizzo Di Fatturazione',
            'ShippingAddressText': 'L\'indirizzo di spedizione è lo stesso dell\'indirizzo di fatturazione.',
            'CartEmptyText': 'Il tuo carrello è vuoto!',
            'NoItemFound': 'Nessun oggetto trovato',
            'goToShop': 'Vai a fare la spesa',
            'cardNumber': 'Numero di carta',
            'expiryDate': 'Data di scadenza',
            'cvv': 'CVV',
            'nameOnCard': 'Nome sulla carta',
            'confirmPayment': 'Conferma pagamento'
        },
        'compenets': {
            'choose': 'Scegli',
            'username': 'Nome utente',
            'passwords': 'Parola d\'ordine',
            'signIn': 'Accedi',
            'dontHaveAccountSignUp': 'Non ho accesso all\'account',
            'enterUserName': 'Inserisci nome utente',
            'enterEmailAddress': 'Inserisci indirizzo email',
            'confirmPasswords': 'Conferma password'
        },
        'themeOptions': {
            'sidebarOverlay': 'Overlay della sidebar',
            'sidebarBackgroundImages': 'Immagini di sfondo della sidebar',
            'appSettings': 'Impostazioni app',
            'sidebarImage': 'Immagine della sidebar',
            'miniSidebar': 'Mini Sidebar',
            'boxLayout': 'Layout casella',
            'rtlLayout': 'Rtl Layout',
            'darkMode': 'Modalità oscura',
            'sidebarLight': 'Leggero',
            'sidebarDark': 'Buio',
            'themeColor': 'Tema Colore'
        },
        'button': {
            'cancel': 'Annulla',
            'add': 'Aggiungi',
            'update': 'Aggiorna',
            'reply': 'Rispondi',
            'delete': 'Elimina',
            'yes': 'Sì',
            'viewAll': 'Guarda tutto',
            'like': 'Piace',
            'assignNow': 'Assegna ora',
            'seeInsights': 'Vedi approfondimenti',
            'acceptTerms': 'Accetta i termini',
            'reject': 'Rifiutare',
            'addNew': 'Aggiungere nuova',
            'goToCampaign': 'Vai alla campagna',
            'viewProfile': 'Vedi profilo',
            'sendMessage': 'Invia messaggio',
            'saveNow': 'Salva ora',
            'pen': 'Penna',
            'search': 'Ricerca',
            'downloadPdfReport': 'Scarica il rapporto Pdf',
            'primary': 'Primario',
            'secondary': 'Secondario',
            'danger': 'Pericolo',
            'info': 'Informazioni',
            'success': 'Successo',
            'warning': 'avvertimento',
            'link': 'collegamento',
            'smallButton': 'Pulsante piccolo',
            'largeButton': 'Pulsante grande',
            'blockLevelButton': 'Pulsante a livello di blocco',
            'primaryButton': 'Pulsante primario',
            'button': 'Pulsante',
            'save': 'Salvare',
            'openMenu': 'Apri Menu',
            'openWithFadeTransition': 'Apri con dissolvenza',
            'openPopover': 'Apri Popover',
            'accept': 'Accettare',
            'click': 'Clic',
            'complete': 'Completare',
            'back': 'Indietro',
            'next': 'Il prossimo',
            'completeStep': 'Completa il passo',
            'error': 'Errore',
            'writeNewMessage': 'Scrivi un nuovo messaggio',
            'saveChanges': 'Salva I Cambiamenti',
            'addNewUser': 'Aggiungi nuovo utente',
            'more': 'Di Più',
            'useDefaultImage': 'Usa immagine predefinita',
            'cropImage': 'Ritaglia l\'immagine'
        },
        'hint': {
            'whatAreYouLookingFor': 'Che cosa sta cercando',
            'searchMailList': 'Cerca nella lista delle mail'
        },
        'module': {
            'inbox': 'Posta in arrivo',
            'drafts': 'bozze',
            'sent': 'Inviato',
            'trash': 'Spazzatura',
            'spam': 'Spam',
            'frontend': 'Fine frontale',
            'backend': 'Backend',
            'api': 'Api',
            'issue': 'Problema'
        },
        'documents': {},
        'common': {},
        'logout': {},
        'login': {},
        'actions': {},
        'sign_up': {}
    }
};
